import { SetStateType } from 'commonTypes';
import { classNames } from 'helpers/validation';
import { FormattedMessage } from 'react-intl';

interface MultiCheckBoxProps {
  multiple: boolean;
  setMultiple: SetStateType<boolean>;
  disabled: boolean;
}

export const MultiCheckBox = ({
  multiple,
  setMultiple,
  disabled,
}: MultiCheckBoxProps) => {
  return (
    <div className={classNames('relative flex items-start', disabled && 'opacity-70')}>
      <div className="flex h-6 items-center">
        <input
          disabled={disabled}
          id="multi-price"
          checked={multiple}
          onChange={(e) => {
            if (!disabled) {
              setMultiple(e.target.checked);
            }
          }}
          aria-describedby="multi-price"
          name="multi-price"
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
        />
      </div>
      <div className="ml-1.5 text-sm leading-6">
        <label htmlFor="multi-price" className="font-medium text-gray-900 select-none">
          <FormattedMessage id="multiPrice" />
        </label>
      </div>
    </div>
  );
};
